/**
 * Modern-theme line icon. Renders an empty <i> whose glyph comes from a CSS
 * mask (see "2d. Document editor" in modern-theme.css), so the icon inherits
 * `color` and never ships a React SVG per usage.
 */
export type GmIconName =
  | "user"
  | "calendar"
  | "truck"
  | "phone"
  | "mail"
  | "pin"
  | "plus"
  | "minus"
  | "x"
  | "trash"
  | "save"
  | "send"
  | "printer"
  | "export"
  | "more"
  | "chevron"
  | "search"
  | "file"
  | "note"
  | "lock"
  | "coins"
  | "tag"
  | "receipt"
  | "calculator"
  | "pencil"
  | "expand"
  | "layers"
  | "square"
  | "clipboard"
  | "briefcase"
  | "arrow-left"
  | "arrow-right";

interface GmIconProps {
  name: GmIconName;
  size?: number;
  className?: string;
}

const GmIcon = ({ name, size, className }: GmIconProps) => (
  <i
    aria-hidden
    className={className ? `gm-ico ${className}` : "gm-ico"}
    data-icon={name}
    style={size ? { width: size, height: size } : undefined}
  />
);

export { GmIcon };
